var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-cotainer',[_c('h2',[_vm._v("four-oh-three")]),_c('p',[_vm._v("Website says no. Sorry, not only are you not allowed to access this page, you are forbidden!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }